import { useAbandonCheckoutMutation, useCheckoutToken, useOrderSource } from '../../state'
import { isAppleRetailOrder } from '../../state/checkout/helper'

export const useCallAbandonCheckout = (): (() => Promise<void>) => {
  const [abandonCheckout] = useAbandonCheckoutMutation()
  const checkoutToken = useCheckoutToken()
  const orderSource = useOrderSource()

  return async (): Promise<void> => {
    if (isAppleRetailOrder(orderSource)) {
      try {
        await abandonCheckout({ token: checkoutToken }).unwrap()
      } catch {
        // ignore error
      }
    }
  }
}
